"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matching_buyers = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var matching_buyers = function matching_buyers(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'matching-buyers-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    d: 'M11 17.4047C11 16.5763 11.6716 15.9047 12.5 15.9047H15.5C16.3284 15.9047 17 16.5763 17 17.4047V17.9047C17 18.0869 17 18.2578 17 18.4049C17 18.681 16.7761 18.9047 16.5 18.9047H11C11 18.9047 11 18.457 11 17.9047V17.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M12.5 14.4047C12.5 13.5763 13.1716 12.9047 14 12.9047C14.8284 12.9047 15.5 13.5763 15.5 14.4047C15.5 15.2332 14.8284 15.9047 14 15.9047C13.1716 15.9047 12.5 15.2332 12.5 14.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M7.00001 17.4047C7.00001 16.5763 7.67158 15.9047 8.50001 15.9047H11.5C12.3284 15.9047 13 16.5763 13 17.4047V17.9047C13 18.0869 13 18.2578 13 18.4049C13 18.681 12.7761 18.9047 12.5 18.9047H7C7 18.9047 7.00001 18.457 7.00001 17.9047V17.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M8.50001 14.4047C8.50001 13.5763 9.17158 12.9047 10 12.9047C10.8284 12.9047 11.5 13.5763 11.5 14.4047C11.5 15.2332 10.8284 15.9047 10 15.9047C9.17158 15.9047 8.50001 15.2332 8.50001 14.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M3 17.4047C3 16.5763 3.67157 15.9047 4.5 15.9047H7.5C8.32843 15.9047 9 16.5763 9 17.4047V17.9047C9 18.457 9 18.9047 9 18.9047H3.5C3.22386 18.9047 3 18.681 3 18.4049C3 18.2578 3 18.0869 3 17.9047V17.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    d: 'M4.5 14.4047C4.5 13.5763 5.17158 12.9047 6 12.9047C6.82843 12.9047 7.5 13.5763 7.5 14.4047C7.5 15.2332 6.82843 15.9047 6 15.9047C5.17158 15.9047 4.5 15.2332 4.5 14.4047Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M13.2646 5.10912C13.5659 5.39333 13.5798 5.868 13.2956 6.16933L9.52289 10.1693C9.2469 10.4619 8.78922 10.4847 8.48552 10.221L6.75825 8.721C6.4455 8.44941 6.41214 7.97571 6.68374 7.66296C6.95533 7.35022 7.42903 7.31686 7.74178 7.58845L8.92557 8.61648L12.2044 5.14012C12.4886 4.83879 12.9633 4.82491 13.2646 5.10912Z',
    fill: '#4B5563'
  }));
};

exports.matching_buyers = matching_buyers;